module.exports = __webpack_public_path__ + "static/media/30.f5a4048c.mp3";